<template>
  <div class="orders-container">
    <div v-if="hasOrders" class="orders-list" @scroll="onScroll">
      <div
        v-for="item in orders"
        :key="item.id"
        class="orders-list__item order-item"
        @click="open(item, $event)"
      >
        <div class="order-item__left">
          <div class="order-item__head">
            <p
              class="order-item__info order-item__info_foz14 order-item__info_mb10 order-item__flex"
            >
              <img src="@/assets/images/clock-2.svg" alt />
              <span>{{ formatOrderDate(item.should_started_at) }}</span>
            </p>
            <p
              class="order-item__info order-item__info_foz14 order-item__info_mb10 order-item__flex"
            >
              <img src="@/assets/images/map-pin.svg" alt />
              <span v-if="item.address">
                {{ item.address.street }}
                {{ item.address.house }},
                {{ item.address.postcode || "00001" }},
                {{ item.address.city }}
              </span>
            </p>
            <div
              class="order-item__info order-item__info_foz14 order-item__flex order-item__info_mb10"
            >
              <p class="order-item__info order-item__info_foz14 order-item__flex m_mr_0">
                <img src="@/assets/images/money.svg" alt />
                <span>{{ printPrice(item.total_price) }}</span>
              </p>

              <p
                v-if="item.service"
                class="order-item__info order-item__info_foz14 order-item__info_service order-item__flex s_m"
              >
                <img :src="item.service.icon" width="16px" alt />
                {{ item.service.title }}
              </p>
            </div>
          </div>
          <div class="order-item__bottom">
            <!-- <p class="order-item__info order-item__info_foz14 order-item__flex">
                            <img src="@/assets/images/no-photo-male.jpg" width="24px" alt="">
                            Tobias Steiner 
            </p>-->

            <p
              v-if="item.service"
              class="order-item__info order-item__info_foz14 order-item__info_service order-item__flex h_m"
            >
              <img :src="item.service.icon" width="16px" alt />
              {{ item.service.title }}
            </p>
          </div>
        </div>
        <div class="order-item__right">
          <!-- <button class="order-item__files-btn" @click="openFiles(item, $event)">Upload files</button> -->

          <orders-list-btn
            class="order-item__info order-item__status"
            :class="`order-item__status_${item.status}`"
            :status="item.status"
            @click="open(item, $event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import dateMixin from "@/mixins/date";
import ordersListBtn from "@/components/buttons/orders/listBtn";
import printPrice from "@/mixins/price/printPrice";

import orders from "@/mixins/orders";

export default {
  name: "orders-list",
  mixins: [dateMixin, printPrice, orders],
  components: {
    ordersListBtn
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      orders: "orders/list",
      isLastPage: "orders/isLastPage"
    }),
    hasOrders() {
      return this.orders != null;
    }
  },
  methods: {
    ...mapMutations({
      setState: "main/setState",
      setIsComponent: "orders/setIsComponent",
      setStateOrder: "orders/setState",
      incPage: "orders/incPage"
    }),
    ...mapActions({
      fetchById: "orders/fetchById",
      update: "orders/update",

      fetchFiles: "orders/fetchFiles"
    }),
    async openFiles({ id, status }) {
      // this.setStateOrder({
      //   key: "isComponent",
      //   value: "mainView"
      // });
      this.setStateOrder({
        key: "isComponent",
        value: "mainView"
      });

      const response = await this.fetchById(id);
      await this.fetchFiles(id);

      // open modal window
      this.setState({
        key: "mainModal",
        value: true
      });

      this.setStateOrder({
        key: "isShowEditAndComment",
        value: true
      });

      return;
    },
    async open({ id, status }, { target }) {
      const nodeName = target.nodeName;
      // set main view
      if (
        nodeName === "BUTTON" &&
        (status === "new" || status === "confirmed" || status === "stand_by")
      ) {
        this.openFiles({ id, status });
        return;
      }

      this.setStateOrder({
        key: "isComponent",
        value: "mainView"
      });

      if (nodeName === "BUTTON") {
        // accept work
        if (status == "job_finished") {
          await this.update({
            id,
            form: {
              status: "payment"
            }
          });

          this.fetchOrdersMixin();
          this.$log("orderStatus_acceptWork");
          return;
        }

        // set payment or rate view
        this.setIsComponent(status);
      }

      // get order by id
      const response = await this.fetchById(id);
      this.fetchFiles(id);

      // open modal window
      this.setState({
        key: "mainModal",
        value: true
      });
    },
    async onScroll({ target: { scrollTop, scrollHeight, offsetHeight } }) {
      const isBottom = scrollTop + offsetHeight > scrollHeight - 30;

      if (this.loading || !isBottom || this.isLastPage) {
        return;
      }

      this.loading = true;
      this.incPage();

      this.fetchOrdersMixin("add");

      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }
  }
};
</script>

<style lang="scss">
.orders-container {
  width: calc(100vw - 310px);
  height: calc(100vh - 210px);
  overflow-x: auto;
  margin-top: 24px;
}

.orders-list {
  width: 100%;
  padding: 3px;
  overflow-y: scroll;
  height: 100%;

  &__item {
    // height: 85px;

    border-top: 1px solid;
    border-color: rgba(229, 231, 235, 1);
    display: flex;
  }
}

.order-item {
  // border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  // box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);
  z-index: 1;
  padding: 16px;
  transition: all 0.3s linear;
  cursor: pointer;
  border-radius: 4px;
  position: relative;
  margin-bottom: 2px;
  background-color: #fff;
  &::before {
    position: absolute;
    z-index: 1;
    content: "";
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  &__info {
    margin: 0;
    text-align: left;
    color: #828282;

    &_foz14 {
      font-size: 14px;
    }

    &_bold {
      font-weight: 600;
    }

    &_mb10 {
      margin-bottom: 10px;
    }
  }

  &__right {
    margin-left: auto;
  }

  &__files-btn {
    position: relative;
    z-index: 9999;
  }

  &:hover {
    background: linear-gradient(
        0deg,
        rgba(155, 205, 130, 0.15),
        rgba(155, 205, 130, 0.15)
      ),
      #ffffff;
  }

  &_completed {
    padding: 5px;
    background-color: rgba(213, 245, 246, 1);
    border-radius: 5px;
  }

  &__head {
    display: flex;
    align-items: center;
  }

  &__bottom {
    display: flex;
    align-items: center;
  }

  &__flex {
    display: flex;
    align-items: center;
    margin-right: 20px;

    img {
      margin-right: 6px;
    }
  }

  &__status {
    font-size: 14px;
    font-family: "crossten";
    position: relative;
    z-index: 99;
    color: #bdbdbd;

    // &_new {

    // }

    // &_canceled {
    //     color: #D53E29;
    // }

    // &_confirmed {
    //     color: #9BCD82;
    // }

    // &_closed {
    //     color: #502D8C;
    // }

    // &_master_on_the_way {
    //     color: #F8CC1C;
    // }

    // &_job_started {
    //     color: #00D8FF;
    // }

    &_button {
      width: 100%;
      height: 100%;
      // box-shadow: 0px 4px 10px rgba(155, 205, 130, 0.5);
      border-radius: 4px;
      color: #0c0c0c;
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      outline: none;
      min-height: 24px;
      max-height: 35px;
      cursor: pointer;
      text-align: center;
    }

    &_job_finished {
      background: #9bcd82;
    }

    &_payment {
      background: #00d8ff;
    }

    &_rating_review {
      background: #f8cc1c;
    }

    // &_new,
    // &_confirmed,
    // &_stand_by {
    //   background: #e4e4e4;
    // }
  }
}

.s_m {
  display: none;
}

@media only screen and (max-width: 768px) {
  .order-item__files-btn {
    position: absolute;
    bottom: 20px;
    right: 10px;
  }

  .h_m {
    display: none;
  }

  .s_m {
    display: flex;
  }

  .m_mr_0 {
    margin-right: 5px;
  }

  .order-item {
    padding: 10px;

    &__left {
      width: 75%;
    }

    &__right {
      width: 25%;
    }

    &__head {
      flex-direction: column;
      align-items: flex-start;
    }

    &__bottom {
      flex-direction: column;
      align-items: flex-start;
    }

    &__info {
      font-size: 12px;

      &_service {
        img {
          display: inline-block;
          margin: 0 4px 0 4px;
        }
      }
    }

    &__status {
      width: max-content;
      right: 10px;
      position: absolute;
      font-size: 11px;
      top: 15px;

      &_button {
        top: 8px;
        max-height: 28px;
      }
    }
  }

  .orders-container {
    width: calc(100vw - 42px);
  }
}

@media (max-width: 568px) {
  .orders-container {
    width: calc(100vw - 22px);
  }
}
</style>
